import { useState } from 'react'
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts'
import stringHelpers from '../../../utilities/stringHelpers'
import { AnalyticsSlider } from '../../shared/analyticsSlider'
import { vehicleAnalyticsChartColours } from '../../../utilities/constants'

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null
    const { name, value, payload: p } = payload[0]
    return (
        <div className="analytics-tooltip">
            <div className="analytics-tooltip-header">
                <span className="analytics-tooltip-dot" style={ { background: p.fill } } />
                <span className="analytics-tooltip-name">{ name }</span>
            </div>
            <span className="analytics-tooltip-value">{ stringHelpers.formatDecimal(value, 2) } vehicle{ value !== 1 ? "s" : "" } &nbsp;·&nbsp; { stringHelpers.formatDecimal(p.percent, 0) }%</span>
        </div>
    )
}

export const FuelTypePieChart = ({ breakdown }) => {
    const total = Object.values(breakdown).reduce((a, b) => a + b, 0)

    const sorted = Object.entries(breakdown)
        .map(([name, value]) => ({ name, value, percent: ((value / total) * 100) }))
        .sort((a, b) => b.value - a.value)

    const colourMap = Object.fromEntries(sorted.map(({ name }, i) => [name, vehicleAnalyticsChartColours[i % vehicleAnalyticsChartColours.length]]))

    const max = Math.max(2, sorted.length)
    const [limit, setLimit] = useState(max)

    const limited = sorted.length > limit
        ? [...sorted.slice(0, limit), { name: "OTHER", value: sorted.slice(limit).reduce((s, d) => s + d.value, 0), percent: sorted.slice(limit).reduce((s, d) => s + d.percent, 0) }]
        : sorted

    return (
        <div className="analytics-chart-card">
            <div className="analytics-chart-card-header mb-1">
                <p className="analytics-chart-title">Fuel Type</p>
                <AnalyticsSlider label={ `Top ${limit}` } value={ limit } min={ 2 } max={ max } step={ 1 } onChange={ setLimit } />
            </div>
            <ResponsiveContainer width="100%" height={ 190 }>
                <PieChart>
                    <Pie data={ limited } dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={ 80 } strokeWidth={ 0 }>
                        { limited.map((entry) => (
                            <Cell key={ entry.name } fill={ colourMap[entry.name] ?? vehicleAnalyticsChartColours[vehicleAnalyticsChartColours.length - 1] } />
                        )) }
                    </Pie>
                    <Tooltip content={ <CustomTooltip /> } />
                </PieChart>
            </ResponsiveContainer>
            <div className="analytics-legend">
                { limited.map((entry) => (
                    <div key={ entry.name } className="analytics-legend-item">
                        <span className="analytics-legend-dot" style={ { background: colourMap[entry.name] ?? vehicleAnalyticsChartColours[vehicleAnalyticsChartColours.length - 1] } } />
                        <span className="analytics-legend-label">{ entry.name }</span>
                        <span className="analytics-legend-percent">{ stringHelpers.formatDecimal(entry.percent, 2) }%</span>
                    </div>
                )) }
            </div>
        </div>
    )
}
